import React from "react";
import { General } from "../tools/styles";
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from "./RenderIf";

const Current = ({
  currentValue = "",
  valDesc = "",
  units = "",
  unitDesc = "",
  just = "",
  handleChange = function () {
    console.log("no function defined");
  },
}) => {
  return (
    <General.BlockContainer>
      <General.Block>
        <FloatCard width="300px">
          <General.InputCont>
            <General.Input
              className="input"
              type="number"
              name="currentValue"
              value={currentValue}
              onChange={handleChange}
              placeholder=" "
              required
            />
            <General.Label className="placeholder">Current Value</General.Label>
          </General.InputCont>
          <RenderIf isTrue={valDesc.length > 0}>
            <General.InputCont>
              <p>{valDesc}</p>
            </General.InputCont>
          </RenderIf>

          <General.InputCont>
            <General.Input
              className="input"
              type="text"
              name="units"
              value={units}
              onChange={handleChange}
              placeholder=" "
              required
            />
            <General.Label className="placeholder">
              Measurement Units
            </General.Label>
          </General.InputCont>
          <RenderIf isTrue={unitDesc.length > 0}>
            <General.InputCont>
              <p>{unitDesc}</p>
            </General.InputCont>
          </RenderIf>
          <General.InputCont margin="0 1rem">
            <span>Justification</span>
          </General.InputCont>
          <General.InputCont margin="0 1rem">
            <General.Text
              className="input"
              name="currentJust"
              value={just}
              onChange={handleChange}
              placeholder=" "
              required
            ></General.Text>
            <General.Label className="placeholder">
              Measurement source?
            </General.Label>
          </General.InputCont>

          <General.InputCont>
            <p>You can drag the lower right corner to make more room.</p>
          </General.InputCont>
        </FloatCard>
      </General.Block>
      <General.Block color={theme.colors.grey4}>
        <div>
        <h2 style={{ width: "250px" }}>Current or Most Recent Metric Value</h2>
        <General.LimitText width="250px">
          Please note if your cursor is inside an input box while you scroll up
          or down, it may change the number value.
        </General.LimitText>
        </div>
      </General.Block>
    </General.BlockContainer>
  );
};

export default Current;
